import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import Grid from "@material-ui/core/Grid/Grid";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbOfferGridInnerBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <Grid container spacing={0} direction="row" justiy="center" alignItems="center" className={`offer-grid-inner ${props.attributes.className ? props.attributes.className : ''} ${classes.offerGridInner} ${classes.offerGridInnerTheme}`}>
        <Grid item xs={12} md={6} className="image-wrap">
            {blocks[0]}
        </Grid>
        <Grid item xs={12} md={6} className="con-wrap">
            {props.attributes.hasTag === true &&
                <div className="day-tag">{props.attributes.tag}</div>
            }
            {blocks[1]}
            {blocks[2]}
            {props.attributes.hasButton === true &&
                blocks[3]
            }
        </Grid>
    </Grid>
};

export const CgbOfferGridInnerBlockFragment = graphql`
  fragment CgbOfferGridInnerBlock on WpBlock {
    ... on WpCgbOfferGridInnerBlock {
        name
        attributes {
            ... on WpCgbOfferGridInnerBlockAttributes {
                className
                tag
                hasTag
                hasButton
            }
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbOfferGridInnerBlockPreview = `
    ... on CgbOfferGridInnerBlock {
        name
        attributes {
            ... on CgbOfferGridInnerBlockAttributes {
                className
                tag
                hasTag
                hasButton
            }
        }
    }
`;